/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "./src/styles/theme.scss"

// https://www.gatsbyjs.org/packages/gatsby-background-image/#important
export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    console.log(`# IntersectionObserver is polyfilled!`)
    return import(`intersection-observer`)
  }
}
